export default "__VITE_ASSET__E1hV35gm__"